import React from 'react';
import style from './errorsDisplay.module.scss';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import classNames from 'classnames';

interface ErrorsDisplayProps {
    errors: Array<string | FormattedMessage.MessageDescriptor>;
    showUpArrow?: boolean;
    className?: string;
}

const ErrorsDisplayPresentational: React.SFC<ErrorsDisplayProps & InjectedIntlProps> =
    ({errors, showUpArrow = false, className, intl}) => {

    if (errors.length === 0) {
        return (null);
    }

    const errorStrings = errors.map(err => typeof(err) === 'string'
        ? err
        : intl.formatMessage(err));

    return (
        <div className={classNames(style.ErrorsContainer, className)}>
            {showUpArrow && <div className={style.UpArrow} />}
            {errorStrings.map((error, index) => <div key={index} className={style.Error}>{error}</div>)}
        </div>
    );
};
const ErrorsDisplay = injectIntl(ErrorsDisplayPresentational);

export { ErrorsDisplay };
